import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Azuresecuritytemplate extends Component {
 
  render() {
    const course =[
      {
        title: "AZ-500: Microsoft Azure Security Technologies",
        content: []
      },
        {
        title: "Introduction to Azure Security",
        content: [
        "Introduction to Azure Security Center",
        "Azure Security Center architecture",
        "Threat detection",
        "Azure Defender",
        "Azure Sentinel",
        "Azure Information Protection",
        "Azure Key Vault",
        "Azure Firewall",
        "Azure DDoS Protection"
        ]
        },
        {
        title: "Identity and Access Management",
        content: [
        "Azure Active Directory (AD) management",
        "Azure AD Identity Protection",
        "Multi-factor authentication",
        "Azure AD Privileged Identity Management (PIM)",
        "Role-based access control (RBAC)",
        "Azure AD Application Proxy",
        "Azure AD Domain Services"
        ]
        },
        {
        title: "Platform Protection",
        content: [
        "Virtual Network (VNet) security",
        "Network Security Groups (NSGs)",
        "Azure Bastion",
        "Azure VPN Gateway",
        "Azure ExpressRoute",
        "Azure DDoS Protection Standard",
        "Azure Application Gateway",
        "Azure Load Balancer",
        "Azure Front Door"
        ]
        },
        {
        title: "Data and Application Protection",
        content: [
        "Azure Storage security",
        "Azure SQL Database security",
        "Azure Database for MySQL security",
        "Azure Database for PostgreSQL security",
        "Azure Cosmos DB security",
        "Azure Key Vault integration with Azure services",
        "Web application firewall (WAF)",
        "Azure CDN"
        ]
        },
        {
        title: "Security Operations",
        content: [
        "Azure Security Center management",
        "Azure Security Center policies",
        "Azure Monitor",
        "Azure Log Analytics",
        "Azure Sentinel",
        "Azure Automation",
        "Azure Resource Manager (ARM) templates",
        "Azure Security Center integrations",
        "Azure Security Center API"
        ]
        },
        {
        title: "Governance and Compliance",
        content: [
        "Azure Policy",
        "Azure Blueprint",
        "Azure Resource Manager (ARM) templates",
        "Azure Compliance Manager",
        "Azure Government Cloud",
        "Azure China Cloud",
        "Azure Sovereign Clouds",
        "General Data Protection Regulation (GDPR)",
        "California Consumer Privacy Act (CCPA)"
        ]
        }
      ]

      const faqData = [
        {
          question: 'How does Azure Security training benefit IT professionals?',
          answer:
            'Azure Security training equips professionals with skills to design, implement, and manage robust security solutions tailored for Azure environments.',
        },
        {
          question: 'How does Azure Security training contribute to effective threat detection and response?',
          answer:
            'Azure Security training covers techniques for proactive threat detection, rapid incident response, and continuous security monitoring on Azure.',
        },
        {
          question: "What are the benefits of using Azure Security?",
          answer:
            'Azure Security provides several benefits, including increased protection against cyber threats and attacks, improved compliance with security and privacy regulations, and enhanced visibility and control over security risks',
        },
        {
          question: `What career opportunities are available for someone with ${this.props.title} skills?`,
          answer:
            ' A person with Azure Security skills can pursue a variety of career opportunities such as Azure Security Engineer, Cloud Security Analyst, Information Security Manager, and Cybersecurity Consultant.',
        },
        {
          question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
          answer:
            'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
        },
      ];
      const EligibilityData=[
        {
          cnt:"learnsoft.org's Azure Security training typically requires basic knowledge of cybersecurity concepts and familiarity with Microsoft Azure services. Prerequisites may include completion of foundational Azure courses or certifications such as AZ-900 or AZ-104. Technical background or experience in IT security is advantageous. Educational qualifications in fields like computer science or information security may be beneficial. Access to an Azure subscription for hands-on practice might be necessary. Specific requirements may vary based on the course level or specialization. For accurate details, consult learnsoft.org's official documentation or contact their support team directly."
        },
      ]
  
      const ReviewData=[
        {
            img:"/course-img/course-review/learnsoft-logo.webp",
            Username:"Moorthi",
            date:" Sep 09 ,2023",
            review:` learnsoft.org has established itself as a trusted name in the field of IT and data engineering training in ${this.props.location} . With a proven track record, they are the perfect place to embark on your Azure Security journey.`
        },
        { img:"/course-img/course-review/learnsoft-logo.webp",
            Username:"Sharma",
            date:" Oct 29 ,2023",
            review:`The Azure Security  Training program at learnsoft.org Institute covers a comprehensive range of topics.Upon successful completion of the Azure Security  program, learnsoft.org provides certification. This certification is recognized in the industry and can open doors to various career opportunities.`
        },
    ]
    return(
      <>
         
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="Azure Security refers to security tools and capabilities available on Microsoft&apos;s Azure cloud platform.Azure Firewall is a cloud-native and intelligent network firewall security service that provides threat protection for your cloud workloads running in Azure. It&apos;s a fully stateful firewall as a service with built-in high availability and unrestricted cloud scalability."/>
            */}
            
            <NewMainsec rating='4.5' students={'749'} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="Azure Security refers to security tools and capabilities available on Microsoft&apos;s Azure cloud platform.Azure Firewall is a cloud-native and intelligent network firewall security service that provides threat protection for your cloud workloads running in Azure. It&apos;s a fully stateful firewall as a service with built-in high availability and unrestricted cloud scalability."/>
           
           
            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		        <Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`Azure Security ${this.props.location1} is an in-demand field with a growing demand for professionals with Azure Security skills. At Learnsoft.org, we offer top-notch Azure Security training courses in ${this.props.location} to help individuals enhance their skills and gain a comprehensive understanding of Azure Security principles and practices. Our experienced trainers use a hands-on approach, incorporating real-world scenarios and practical exercises to provide a well-rounded education in Azure Security. Whether you're new to Azure Security or looking to expand your skillset, Learnsoft.org's Azure Security ${this.props.location1} is the perfect choice to take your career to the next level. Contact us today to learn more about our courses and start your Azure Security journey.`} 
            title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our Azure Security course covers a wide range of topics, including security governance, identity and access management, threat protection, and security monitoring. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in Azure Security. By the end of the course, you will be able to implement Azure Security practices in your own projects and secure your cloud infrastructure."}/>
           </section>
 <Batchtime title={this.props.title} fees="25,999" offer="18,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1}  cou3="DevOps" coupath3="devops" cou='Azure DevOps' coupath='azure-devops' cou1='Azure Administration' coupath1='azure-admin' cou5='Azure Solution Architect' coupath5='azure-solution-architect' cou6='Azure Data Engineering' coupath6='azure-data-engineering'
          cou9='Kubernetes' coupath9='kubernetes' cou8='Jenkins' coupath8='jenkins' cou7='GoCD' coupath7='gocd'
          cou10='Terraform' coupath10='terraform' cou4='Azure' coupath4='azure'  cou2='DevSecOps' coupath2='devsecops' />

      </>
    );
  }
}
